import { HomeBatteryIcon } from './HomeBatteryIcon';

/**
 * author: Michael Irigoyen
 * id 3BCACB97-3EEE-453B-81A7-1136F167B23D
 * name home-battery
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-battery.svg
 * tags
 * - Home Automation 
 * - Battery 
 */
export const HousePowerIcon = HomeBatteryIcon;
export default HousePowerIcon